import {Component} from "../../gvf/js/component";
import {GvfService} from "../../gvf/js/gvf-service";
import {GvfUiService} from "../../gvf/js/gvf-ui-service";

export class Page extends Component{
    showLoading(){
        const $page = $("body");
        $page.addClass("is-starting-loading");
        GvfService.delay(5,"loading").then(
            () => {
                if($page.hasClass("is-starting-loading")){
                    $page.addClass("is-loading");
                }
            }
        );
    }

    hideLoading(){
        $("body").removeClass("is-starting-loading is-loading");
    }

    //#region Dropzone Files
    renderFileView(){
        this.$root.find(".pdf-show").click(ev => {
            ev.preventDefault();
            ev.stopPropagation();
            $(ev.currentTarget).addClass("is-loading");

            GvfService.endpoint(this.$root.data("controller")+"/render-file-view",
                {fileId: $(ev.currentTarget).data("repid") ?? 0}
            ).then(resp=>{
                let $modalView = $(resp.html);
                $("body").append($modalView);
                GvfUiService.init($modalView);
                $modalView.modal("show");
                $modalView.on("hidden.bs.modal",()=>{
                    $modalView.remove();
                });
                $(ev.currentTarget).removeClass("is-loading");
            })

            $(ev.currentTarget).removeClass("is-loading");
        });
    }

    viewFiles(modelName=''){
        this.$root.find(".pdf-show").click(ev => {
            ev.preventDefault();
            ev.stopPropagation();
            $(ev.currentTarget).addClass("is-loading");
            if(modelName.length<=0){
                modelName = this.$root.find('div[data-model-name]').data('model-name') ?? "";
            }
            let params = {
                url: $(ev.currentTarget).data("url") ?? "",
                fileId: $(ev.currentTarget).data("doc") ?? 0,
                objectId: this.$root.find('input[type="hidden"][name="id"]').val() ?? 0,
                modelName: modelName
            }

            GvfService.endpoint(this.$root.data("controller")+"/render-file-url-view",{params:params}).then(resp=>{
                let $modal = $(resp.html);
                $("body").append($modal);
                GvfUiService.init($modal);
                $modal.modal("show");
                $modal.on("hidden.bs.modal",()=>{
                    $modal.remove();
                });
                $(ev.currentTarget).removeClass("is-loading");
            })
            $(ev.currentTarget).removeClass("is-loading");
        });
    }

    /**
     * @param {jQuery} $viewContainer
     */
    prepareFiles($viewContainer){
        $viewContainer.find(".dz-preview").each((index, item) => {
            let file = $viewContainer.data("files")[index];
            let url = file["detailUrl"].replace("?d=1", "").split("/");
            let extension = url[url.length - 1].split(".")[1];
            let btn = `<div class="text-center">`;

            if(["jpg","jpeg","png","pdf","doc","docx","xls","xlsx","txt"].includes(extension)){
                btn += `<button type="button" data-repid="${$viewContainer.data("files")[index]["id"]}" class="btn btn-sm btn-outline-primary waves-effect waves-light pdf-show"><i class="mdi mdi-eye"></i></button>`
            }

            btn += `<a href="${file["detailUrl"]}" target="_blank" class="btn btn-sm btn-outline-primary waves-effect waves-light file-download"   data-target=""><i class='mdi mdi-download'></i></a></div>`;
            $(item).find(".dz-details").append(btn);

            //To open modal without download
            file["detailUrl"] = "";
            $(".dz-remove").css("margin-top", "8%");
        });
    }

    prepareFilesContainers(){
        //Have to use on children to specific containers
    }
    //#endregion

    ready(){
        //specific code
        window.addEventListener("scroll",
            (ev)=>{
                if(window.scrollY > 100){
                    $(".cp-center-page").addClass("is-scrolling");
                } else {
                    $(".cp-center-page").removeClass("is-scrolling");
                }
        });
        $(document).find(`.js-detail-page__mobile-back-link`).click((ev)=>{
            ev.preventDefault();
            window.history.back();
        });
    }
}